import type { Configuration } from '@azure/msal-browser';

import { env } from '@/env';

type RedirectLocation = Pick<Location, 'origin' | 'hostname'>;

const localhostHostnames = new Set(['localhost', '127.0.0.1', '::1']);

export const resolveRedirectUri = (location: RedirectLocation | null | undefined): string => {
  const origin = typeof location?.origin === 'string' ? location.origin : '';
  const hostname = typeof location?.hostname === 'string' ? location.hostname.toLowerCase() : '';

  if (!origin) return '';

  return localhostHostnames.has(hostname) ? origin : `${origin}/redirect.html`;
};

const origin = globalThis.location?.origin ?? '';
const redirectUri = resolveRedirectUri(globalThis.location);

export const msalConfig: Configuration = {
  auth: {
    clientId: env.aadClientId,
    authority: `https://login.microsoftonline.com/${env.aadTenantId}`,
    redirectUri,
    postLogoutRedirectUri: origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const protectedResources = {
  graphql: {
    scopes: env.mlGraphScope
      .split(/[\s,]+/)
      .map((scope) => scope.trim())
      .filter(Boolean),
  },
};
